import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";

import UpdateRequest from "@/modules/application/user/components/UpdateRequest";
import { fetchApplicationRequestFlowQueryOptions } from "@/modules/application/user/services";

export const Route = createFileRoute(
  "/_panel/_application/application/requests/$id",
)({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Edit Request", { ns: "application.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchApplicationRequestFlowQueryOptions(opts.params.id),
    ),
});

function Component() {
  const { id } = Route.useParams();

  return <UpdateRequest id={id} />;
}
